<script lang="ts">
    import { newNotification } from "../../../store"
    import { deleteAddress, getAddresses } from "../../../api"
    import { createEventDispatcher } from "svelte"
    import { _ } from "svelte-i18n"
    const dispatch = createEventDispatcher()

    import Modal from "../../widgets/Modal.svelte"
    export let address: Address
    export let show: boolean = false
    let loading: boolean = false

    const confirmed = (): void => {
        loading = true

        if (address.type == "person") {
            deleteAddress(address)
                .then(() => {
                    newNotification({
                        class: "success",
                        html: $_("address.contactDeletedSuccess"),
                        timeout: 3000,
                    })

                    dispatch("address-deleted", {
                        address,
                    })
                })
                .catch((e) => {
                    newNotification({
                        class: "error",
                        html: $_("address.deleteError"),
                        timeout: 6000,
                    })
                })
                .finally(() => {
                    loading = false
                })
        } else
            getAddresses({
                type: "person",
                "person.parentCompany": address.id,
            })
                .then((res) => {
                    let addresses = [address, ...res.data]
                    let deletePromises: Promise<any>[] = []

                    addresses.forEach((address) => {
                        const promise = deleteAddress(address)
                            .then(() => {
                                dispatch("address-deleted", {
                                    address,
                                })
                            })
                            .finally(() => {
                                loading = false
                            })

                        deletePromises.push(promise)
                    })

                    return Promise.allSettled(deletePromises)
                })
                .then((results) => {
                    const successfulDeletes = results.filter((result) => result.status === "fulfilled").length

                    if (successfulDeletes === results.length) {
                        newNotification({
                            class: "success",
                            html: $_("address.multipleDeleteSuccess", {
                                values: {
                                    successfulDeletes: successfulDeletes - 1,
                                },
                            }),
                            timeout: 3000,
                        })
                    } else {
                        newNotification({
                            class: "error",
                            html: $_("address.partialDeleteError"),
                            timeout: 6000,
                        })
                    }
                })
                .catch((e) => {
                    newNotification({
                        class: "error",
                        html: $_("address.unexpectedError"),
                        timeout: 6000,
                    })
                })
    }
</script>

{#if address}
    <Modal
        bind:show
        on:close="{() => {
            show = false
        }}"
    >
        <div slot="header">
            {#if address.type == "person"}
                {$_("address.removeContactHeader")}
            {:else}
                {$_("address.deleteEntryHeader")}
            {/if}
        </div>
        <div>
            {#if address.type == "person"}
                {$_("address.removeContactConfirm")}
            {:else}
                {$_("address.deleteContactConfirm")}
            {/if}
        </div>
        <div slot="footer">
            <button class="btn btn-secondary" on:click="{() => dispatch('canceled')}">
                {$_("address.cancelButton")}
            </button>
            <button class="btn" on:click="{() => confirmed()}">
                {#if address.type == "person"}
                    {$_("address.removeButton")}
                {:else}
                    {$_("address.deleteButton")}
                {/if}
            </button>
        </div>
    </Modal>
{/if}
